import React, { useState } from 'react'

// Deps
// import { connect } from 'react-redux'

// Partials
import Btn from 'views/shared/partials/btn'
import Image from 'views/shared/partials/image'
import Pricebox from 'views/shared/partials/pricebox'
// import Collapser from 'views/shared/partials/collapser'
import { InputForm } from 'views/shared/partials/forms'

// Utils
// import { openModal } from 'utils/modals'

// Services
import orderServices from 'services/order'
import commerceServices from 'services/commerce'

const ReturnOrderProductPreview = ({ orderData, returnData, returnAmount, newTotal, leftProducts, productList, returnProducts, close, onSuccess, ...props}) => {
	const [submitting, setSubmitting] = useState(false);

	const submit = (formData) => {
		setSubmitting(true);
		commerceServices.createOrder({
			order_business_code: orderData.business_order_code,
			client_code: orderData.client.client_code,
			order_store_code: orderData.group.store_code,
			order_price_type_id: orderData.price_type_id,
			order_target_store_code: orderData.target_group.store_code,
			order_total_amount: newTotal,
			product_id: leftProducts
		}).then((posMockPayload) => {
			if (posMockPayload.order_prova_token) {
				try {
					const requestList = [];
					if (posMockPayload.refund_plan && posMockPayload.refund_plan.payments) {
						for (const paymentID in posMockPayload.refund_plan.payments) {
							const payment = posMockPayload.refund_plan.payments[paymentID];

							requestList.push(new Promise((resolve, reject) => {
								orderServices.refundPayment({
									order_business_code: orderData.business_order_code,
									refund_reason: 'Toplu ürün iadesi',
									// refund_price: payment.refund_price,
									// payment_id: payment.payment.id,
									refund_plan_id: payment.refund_plan_id,
									// add_ratio: 1,
									products: JSON.stringify(returnProducts),
								}).then((payload) => {
									resolve({
										success: true,
										process: payment,
										payload: payload,
									})
								}).catch(() => {
									resolve({
										success: false,
										process: payment,
										payload: false,
									})
								})
							}));
						}
					}

					Promise.all(requestList).then((payloads) => {
						let hasError = false;
						for(const payload of payloads) {
							if(!payload.success) { hasError = true }
						}
						if(hasError) {
							close();
							onSuccess({ refunds: payloads });
						}
						else {
							commerceServices.createOrder({
								order_prova_token: posMockPayload.order_prova_token
								// order_business_code: orderData.business_order_code,
								// client_code: orderData.client.client_code,
								// order_store_code: orderData.group.store_code,
								// order_price_type_id: orderData.price_type_id,
								// order_target_store_code: orderData.target_group.store_code,
								// product_id: leftProducts
							}).then(() => {
								close();
								onSuccess({ refunds: payloads });
							}).catch((e) => {
								console.warn('Bir hata oluştu.', e)
							})
						}
					}).catch((e) => {
						console.warn('error', e);
					}).finally(() => {
						setSubmitting(false);
					})
				}
				catch(e) {
					console.warn('Return error: ', e);
				}
			}
			else {
				setSubmitting(false);
				// onSuccess({ refunds: [] });
				// close();
			}
		}).catch(() => {
			setSubmitting(false);
		})
	}

	return (
		<InputForm
			onSubmit={submit}
			className={props.className}>
			<div className="modal-header dark">
				<h1 className="header-title">İade Onayı</h1>
				<button className="modal-closebtn" disabled={submitting} type="button" onClick={close}><i className="icon-close"></i></button>
			</div>

			<div className="modal-content">
				<p className="preview-message">Seçtiğiniz Ürünler İade Edilecek</p>

				<ul className="modal-group preview-products">
					{productList.map((product, nth) => (
						<li className="products-product" key={'return-preview-' + nth}>
							<div className="product-imagewrap">
								<Image src={product.product.image_link} lazy={false} className="product-image" />
							</div>
							<div className="product-text">
								<strong className="text-title">{product.product.title}</strong>
								<div className="text-reason">
									<strong className="reason-title">İade sebebi:</strong>
									<p className="reason-text">
										{product.refund_reason}
									</p>
								</div>
							</div>
							<Pricebox className="product-price" price={product.return_price} />
						</li>
					))}
				</ul>

				<div className="modal-group wide preview-sum">
					<div className="sum-row">
						<strong>İade Edilecek Ürünler Toplamı</strong>
						<Pricebox price={returnData.total} />
					</div>
					<div className="sum-row">
						<strong>Ödenen Bakiyeden İade Edilecek Toplam Tutar</strong>
						<Pricebox warning={returnAmount !== 0} big price={returnAmount} />
					</div>
				</div>
			</div>

			<div className="modal-controls">
				<Btn
					nude
					disabled={submitting}
					onClick={close}>
					Vazgeç
				</Btn>
				<Btn
					loading={submitting}
					disabled={submitting || returnData.total === 0}
					type="submit">
					İade Et
				</Btn>
			</div>
		</InputForm>
	)
}

ReturnOrderProductPreview.defaultProps = {
	className: '',
	containerClass: 'modal-return-order-product-preview mobile-full',
	name: 'return-order-product-preview',
}

export default ReturnOrderProductPreview